import React from 'react';
import Menu from '../components/Navbar';


const interiorDesign = () => {
    return (
        <>
            <Menu />
        </>
    )
}

export default interiorDesign